import React from "react";
import Flatpickr from "react-flatpickr";

const DateField = (props: any) => {
  return (
    <>
      <div className="form-floating">
        <Flatpickr
          className="form-control"
          placeholder="name@example.com"
          {...props}
        />
        <label htmlFor="floatingInput">{props?.placeholder}</label>
      </div>
    </>
  );
};

export default DateField;
